import { ColumnHeightOutlined, PauseCircleOutlined } from "@ant-design/icons";
import CustomTag from "./CustomTag";
import React from "react";
import FanOperationType from "src/consts/FanOperationType";
import FanDTO from "src/models/FanDTO";
import FanRunOperationsDTO from "src/models/FanRunOperationsDTO";

interface FanStatusTagProps{
    fans: FanDTO[] | null | undefined;
    fanOperationState: FanRunOperationsDTO | null | undefined; 
}

// FanDTO built from the platform FanStateDTO only sets isOn (fan.isOn stays null), so check both
const isFanOn = (fan: FanDTO) => (fan.isOn ?? fan.fan?.isOn) === true;

const FanStatusTag : React.FC<FanStatusTagProps> = ({ fans, fanOperationState }) => {

    if(fanOperationState?.fanOperationType === FanOperationType.Automatic){
        if(fanOperationState?.useEmcRange && fanOperationState?.isMcWithinLimits === false){
            return(<CustomTag label={'Fans: PAUSED (EMC)'} icon={<PauseCircleOutlined />} color={'orange'}/>);
        }
        if(fanOperationState?.useTempRange && fanOperationState?.isTemperatureWithinLimits === false){
            return(<CustomTag label={'Fans: PAUSED (TEMP)'} icon={<PauseCircleOutlined />} color={'orange'}/>);
        }
    }

    if(fans?.some(isFanOn)){
        return(<CustomTag label={'Fans: ON'} icon={<ColumnHeightOutlined />} color={'green'}/>);
    }
    return(<CustomTag label={'Fans: OFF'} icon={<ColumnHeightOutlined />} color={'red'}/>);
}

export default FanStatusTag;
